import { render, staticRenderFns } from "./EndedSheet.vue?vue&type=template&id=0e143b43"
import script from "./EndedSheet.vue?vue&type=script&lang=js"
export * from "./EndedSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports